<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { RestaurantAreas } from '~/lib/interfaces/restaurant'

const restaurantStore = useRestaurantStore()
const { fetchListRestaurants, list } = useRestaurantsMOP()
const { modalChangeRestaurant, candidateArea, modalDLV, modalMOP } = storeToRefs(restaurantStore)

const fetching = ref(false)

const showDLVModal = computed(() => {
  return RestaurantAreas.DLV === candidateArea?.value && modalDLV.value
})

const showMOPModal = computed(() => {
  return RestaurantAreas.MOP === candidateArea?.value && modalMOP.value
})

const showChangeRestaurantModal = computed(() => {
  return modalChangeRestaurant.value && !modalDLV.value && !modalMOP.value
})

onMounted(async () => {
  if (process.client && !list.value?.length) {
    fetching.value = true
    await fetchListRestaurants()
    fetching.value = false
  }
})
</script>

<template>
  <Loader v-if="fetching" full />
  <template v-else>
    <ModalChangeRestaurant v-if="showChangeRestaurantModal" />
    <DLVModal v-if="showDLVModal" />
    <MOPModal v-if="showMOPModal" />
  </template>
</template>
